import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ChatService } from '../services/chat.service';

@Injectable({ providedIn: 'root' })
export class ChatConnectionResolver implements Resolve<void> {
  constructor(private chatService: ChatService) {}

  async resolve(): Promise<void> {
    await this.chatService.startConnection();
  }
}
